import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import translations from './translations';

const AlreadyPackedMessage = ({ shipment }) => {
  const history = useHistory();

  const handleClick = () => {
    if (!shipment) {
      return;
    }

    history.replace(`/shipments/${shipment?.id}/parcels`);
  };

  return (
    <Alert
      severity="success"
      action={
        <Button variant="outlined" color="inherit" size="small" onClick={handleClick}>
          <FormattedMessage {...translations.actions.viewParcels} />
        </Button>
      }
    >
      <FormattedMessage {...translations.message} />
    </Alert>
  );
};

AlreadyPackedMessage.propTypes = {
  shipment: PropTypes.object,
};

AlreadyPackedMessage.defaultProps = {
  shipment: undefined,
};

export default AlreadyPackedMessage;
